import React from 'react';
import { Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DATE_FORMAT } from '../../consts';
import { useOpenBalancesSummary } from '../../../openBills/useOpenBalancesSummary';
import { useAreasView } from '../AreasViewContext';

export const PreviousDaysOpenButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { accountToday } = useAreasView();
  const { summary } = useOpenBalancesSummary();

  if (!summary || summary.previous_days_count === 0) {
    return null;
  }

  const yesterday = moment(accountToday, DATE_FORMAT).subtract(1, 'day').format(DATE_FORMAT);
  const labelKey =
    summary.oldest_open_date === yesterday
      ? 'calendar.areas_view.previous_day_open'
      : 'calendar.areas_view.previous_days_open';

  return (
    <Button
      variant="outlined"
      color="error"
      startIcon={<ErrorOutlineIcon />}
      onClick={() => navigate('/dashboard/open-bills')}
      sx={{ minHeight: { xs: 40, md: 44 }, whiteSpace: 'nowrap', flexShrink: 0 }}>
      {t(labelKey, { count: summary.previous_days_count })}
    </Button>
  );
};
